module.exports = __webpack_public_path__ + "img/twitter.f0db9bd8.svg";